import React, {useContext, useEffect, useState} from 'react';
//import { useHistory } from "react-router-dom";
import {AppContext} from '@vf';
import {HoursApiClient} from './HoursApiClient';
import {ConnectApiClient} from './ConnectApiClient';
import {HelpersApiClient} from './HelpersApiClient';
import {HolidaysApiClient} from './HolidaysApiClient';
import {ClosuresApiClient} from './ClosuresApiClient';
import {SyncApiClient} from './SyncApiClient';
import {MenuManagementApiClient} from './MenuManagementApiClient';
import {UserManagementApiClient} from './UserManagementApiClient';
import AmplifyService from '@vf/services/AmplifyService';
import Loader from '../../core/Loader';
import AppContextPropsType from 'types/AppContextPropsType';
import {ContactFlowsApiClient} from './ContactFlowsApiClient';
import {
  HelperApi,
  IConnectApi,
  HolidayApi,
  ClosureApi,
  HourApi,
  IContactFlowsApi,
  ISyncApi,
  IMenuManagementApi,
  IUserManagementApi,
} from 'types/api/api-interfaces';
import {EntryPointManagementApiClient} from './ContactEntryPointsApiClient';
import {QueueTreatmentApiClient} from './QueueTreatmentApiClient';

export interface IApiContext {
  contactflow: IContactFlowsApi;
  closure: ClosureApi;
  connect: IConnectApi;
  helpers: HelperApi;
  holiday: HolidayApi;
  hour: HourApi;
  sync: ISyncApi;
  menu: IMenuManagementApi;
  entryPoint: EntryPointManagementApiClient;
  queueTreatment: QueueTreatmentApiClient;
  userManagement: IUserManagementApi;
}

export const ApiContext = React.createContext<IApiContext>(null as any);

function ApiContextProvider(props: {children: any}) {
  //let history = useHistory();
  const {
    config,
    user,
    updateAuthUser,
    enableTenancy,
    setTenancySetting,
    setAvailableFeatures,
  } = useContext<AppContextPropsType>(AppContext);

  const [state, setState] = useState<IApiContext>(null as any);
  useEffect(() => {
    if (config) {
      const useAuth = config.environment !== 'local';
      setState({
        contactflow: new ContactFlowsApiClient(config.apiUrl, useAuth),
        closure: new ClosuresApiClient(config.apiUrl, useAuth),
        connect: new ConnectApiClient(config.apiUrl, useAuth),
        helpers: new HelpersApiClient(config.apiUrl, useAuth),
        holiday: new HolidaysApiClient(config.apiUrl, useAuth),
        hour: new HoursApiClient(config.apiUrl, useAuth),
        sync: new SyncApiClient(config.apiUrl, useAuth),
        menu: new MenuManagementApiClient(config.apiUrl, useAuth),
        entryPoint: new EntryPointManagementApiClient(config.apiUrl, useAuth),
        queueTreatment: new QueueTreatmentApiClient(config.apiUrl, useAuth),
        userManagement: new UserManagementApiClient(config.apiUrl, useAuth),
      });
      if (!config.cognito) return;

      AmplifyService.setHubListener(
        updateAuthUser,
        enableTenancy,
        setTenancySetting,
        setAvailableFeatures,
      );

      AmplifyService.isAuthenticated().then((bool) => {
        if (bool) {
          AmplifyService.getClaims()
            .then((claims) => {
              if (!claims) {
                AmplifyService.federatedLogin();
              } else {
                if (claims.groups.includes('admin')) {
                  if (claims.tenancyEnabled) {
                    claims.groups.push('tenancyManagement');
                    enableTenancy(true);
                    if (claims.tenancyOn) {
                      setTenancySetting(true);
                    }
                  }
                  setAvailableFeatures(claims.features);
                  updateAuthUser({
                    username: claims.username,
                    userType: 'admin',
                    groups: claims.groups.concat(claims.features),
                    email: claims.email
                  });
                } else {
                  if (claims.tenancyOn) {
                    setTenancySetting(true);
                  }
                  setAvailableFeatures(claims.features);
                  updateAuthUser({
                    username: claims.username,
                    userType: 'user',
                    groups: claims.groups.concat(claims.features),
                    email: claims.email
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
              updateAuthUser(null);
            });
        } else {
          AmplifyService.federatedLogin();
        }
      });
    }
  }, [config, updateAuthUser]);

  return (
    <ApiContext.Provider value={state}>
      {user && state ? props.children : <Loader />}
    </ApiContext.Provider>
  );
}

export default ApiContextProvider;
